import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

export const SET_LOCALE_CONFIG_CODE = 'SET_LOCALE_CONFIG_CODE';

export function createActionSetLocaleConfigCode(code: string): TAction<string> {
  return {
    type: SET_LOCALE_CONFIG_CODE,
    payload: code
  };
}
